import { useTranslation } from 'react-i18next';

import { BaseIngredientTabProps } from 'components/desktop/BaseIngredient/BaseIngredientComponent';
import 'components/desktop/BaseIngredient/BaseIngredientComponent.scss';
import IngredientEditor from 'components/desktop/BaseIngredient/IngredientEditor/IngredientEditor';
import FoldableCard from 'components/desktop/_general/Card/FoldableCard/FoldableCard';
import PERMISSIONS from 'enums/permissions';
import { arePermissionsInUserPermissions } from 'functions/tokenFunctions';

export const BaseIngredientIngredientCard = ({ state }: BaseIngredientTabProps): JSX.Element => {
	const { t } = useTranslation();

	return (
		<FoldableCard
			defaultOpen={true}
			dataComponentType="baseingredient-ingredients-card"
			title={t('_general:INGREDIENTS')}
			content={
				<IngredientEditor
					ingredients={state.ingredients}
					disabled={!arePermissionsInUserPermissions([PERMISSIONS.WRITEBASEINGREDIENT])}
					reader={arePermissionsInUserPermissions([PERMISSIONS.READINGREDIENT])}
				/>
			}
			isInActive={!state.ingredients.length}
		/>
	);
};
